import { message } from 'antd';
import { useEffect, useState } from 'react';
import { getInventory, getDjangoInventory } from '../data/API';
import { getMyData } from '../utils/token';

const useInventory = () => {
  const [inventoryList, setInventoryList] = useState([]);

const shouldLoadInventory = () => {
  const loginType = localStorage.getItem('loginType') || "Storage On-Demand";

  try {
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));

      if (payload.type === 'both_customer') {
        return true;
      }

      if (loginType === "Storage On-Demand" && payload.type === 'customer') {
        return true;
      }

      if (payload.type === 'rental_customer') {
        return true;
      }
    }
  } catch (error) {
    console.warn('Error checking token type:', error);
  }

  return loginType === "Storage On-Demand";
};

  const getCustomerInventory = async () => {
    if (!shouldLoadInventory()) {
      console.log('Skipping inventory load - user type does not have access');
      return;
    }

    // Get fresh user data on each call
    const user = getMyData();

    if (!user || !user.id) {
      console.warn('No user data found, skipping inventory fetch');
      return;
    }

    try {
        let nodeInventory = [];
        let djangoInventory = [];

        try {
          let response = await getInventory(user?.id);
          if (response?.data?.data) {
            nodeInventory = response.data.data;
          }
        } catch (error) {
          console.warn('Node backend inventory fetch:', error);
        }

        try {
          if (user?.email) {
            let djangoResponse = await getDjangoInventory(user.email);

            if (djangoResponse?.data?.success && djangoResponse.data.data?.inventory) {
              djangoInventory = djangoResponse.data.data.inventory.map(item => ({
                ...item,
                storageBox: item.box,
                box_id: item.box?.id,
                storage_order_id: item.storage_order_id,
                order_number: item.order_number,
                delivery_order_id: item.delivery_order_id,  // Map delivery_order_id
                returned_by_id: item.returned_by_id,
                delivery_order_date: item.delivery_order_date,  // Map delivery date
                content_image: item.content_image_url || item.content_image || (item.image ? item.image : null)
              }));
            }
          }
        } catch (error) {
          console.warn('Django backend inventory fetch:', error);
        }

        const mergedMap = new Map();

        nodeInventory.forEach(item => {
          const uniqueKey = `node_${item.id}`;
          mergedMap.set(uniqueKey, item);
        });

        djangoInventory.forEach(item => {
          let foundMatch = false;

          for (let [key, nodeItem] of mergedMap.entries()) {
            if (key.startsWith('node_') &&
                nodeItem.box_id === item.box_id &&
                nodeItem.storage_order_id === item.storage_order_id) {
              mergedMap.set(key, item);
              foundMatch = true;
              break;
            }
          }

          if (!foundMatch) {
            const uniqueKey = `django_${item.id}`;
            mergedMap.set(uniqueKey, item);
          }
        });

        const mergedInventory = Array.from(mergedMap.values());
        setInventoryList(mergedInventory);
    } catch (error) {
        if (shouldLoadInventory()) {
            console.error("Error fetching Inventory:", error);
            return message.error("Error fetching Inventory");
        }
    }
  };

  useEffect(() => {
    getCustomerInventory()
  }, [])

  return {
    inventoryList,
    refreshInventory: getCustomerInventory
  };
};

export default useInventory;